<template>
    <div id="hospManage">
        <div class="breadcrumb">
            <el-breadcrumb separator=">">
                <el-breadcrumb-item>医院管理</el-breadcrumb-item>
            </el-breadcrumb>
        </div>
        <div style="margin:10px 0" align="left">
            <el-row :gutter="10">
                <el-col align="left" :span="16">
                    <el-button type="primary"  @click="addDialog = true" size="small">添加医院</el-button>
                </el-col>
                <el-col align="center" :span="7">
                    <el-input v-model="hospName" size="small" placeholder="医院名称" clearable @keyup.enter.native="query()"></el-input>
                </el-col>
                    <el-col align="center" :span="1">
                    <el-button icon="el-icon-search" size="small" circle @click="query()"></el-button>
                </el-col>
            </el-row>
        </div>
        <div>
            <template class="table">
                <el-table :data="hospList" ref="hospList"  style="width: 100%" @current-change="selectionChange">
                    <el-table-column type="index" align="center" label="序号" > </el-table-column>
                    <el-table-column prop="hospVo.hospName" align="center" label="医院名称" > </el-table-column>
                    <el-table-column prop="hospVo.hospCode" align="center" label="医院编号" > </el-table-column>
                    <el-table-column prop="hospVo.hospAdminName" align="center" label="联系人" > </el-table-column>
                    <el-table-column prop="hospVo.hospAdminTel" align="center" label="电话"></el-table-column>
                    <el-table-column prop="hospVo.hospRank" align="center" label="等级"></el-table-column>
                    <el-table-column prop="hospVo.hospAddr" align="center" label="地址" width="260"></el-table-column>
                    <el-table-column prop="saName" align="center" label="管理员" width="260"></el-table-column>
                </el-table>
            </template>
        </div>
        <div class="page">
            <el-pagination  :page-size="20" :page-count="5" :page-sizes="[10,20,50,100]" layout="total, prev, pager, next,sizes" :total="tablePage" @current-change='changePage' @size-change="changeSize" style="text-align:right"></el-pagination>
        </div>

        <!-- 添加医院弹窗 -->
        <el-dialog title="添加医院" :visible.sync="addDialog" :close-on-press-escape=false width="630px" @close="cancel">
            <el-form :model="addForm" :rules="addHosp" ref="addForm" label-width="100px">
                <el-form-item label="医院名称" prop="hospName">
                    <el-input v-model="addForm.hospName" placeholder="医院名称"></el-input>
                </el-form-item>
                <el-form-item label="医院负责人" prop="hospAdminName">
                    <el-input v-model="addForm.hospAdminName" placeholder="医院负责人"></el-input>
                </el-form-item>
                <el-form-item label="联系电话" prop="hospAdminTel">
                    <el-input v-model="addForm.hospAdminTel" placeholder="联系电话"></el-input>
                </el-form-item>
                <el-form-item label="所在地区" prop="hospAddArr">
                    <city-select @hospAddArr='addArr=>{addForm.hospAddArr=addArr}' :hospCityArr='addForm.hospAddArr' style="width:100%;" />
                </el-form-item>
                <el-form-item label="详细地址">
                    <el-input v-model="addForm.hospAddr" placeholder="详细地址"></el-input>
                </el-form-item>
                <el-form-item label="等级" prop="hospRank">
                    <el-select v-model="addForm.hospRank" placeholder="等级" style="width:100%;">
                        <el-option v-for="item in hospRanks" :label="item.dictDesc" :value="item.dictDesc" :key="item.dictDesc"></el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="医院简介">
                    <el-input type="textarea" v-model="addForm.hospDesc" placeholder="医院简介"></el-input>
                </el-form-item>
            </el-form>
            <el-button @click="cancel()">取 消</el-button>
            <el-button type="primary" @click="save()">确定</el-button>
        </el-dialog>

    </div>
</template>

<script>
import hospImg from '@/assets/hospital.jpg'
import aliUploade from '@/components/upLoad'
import citySelect from '@/components/city'
import {isvalidCallAndPhone} from '@/service/common'
import { Loading } from 'element-ui';
//定义一个全局的变量，手机号格式验证
var validPhone=(rule, value,callback)=>{
    if (!value){
        callback(new Error('请输入电话号码'))
    }else  if (!isvalidCallAndPhone(value)){
        callback(new Error('手机号码格式不对'))
    }else {
        callback()
    }
}
export default {
    name:'hospManage',
    components:{
      'ali-uploade':aliUploade,
      'city-select':citySelect
    },
    props: {
      multiple: {
          type: Boolean,
          twoWay: false
      },
      id: {
          type: String,
          twoWay: false,
      },
      urls: {
          type: Array,
          twoWay: true
      }
    },
    data(){
        return{
            userInfo:'',
            addDialog : false,
            addForm : {
                hospName:'',
                hospAddr:'',
                hospDesc:'',
                hospAdminName:'',
                hospAdminTel:'',
                hospRegionCode:'',
                hospAddArr:[]
            },
            tablePage : 20,
            hospList:[],
            //查询医院名称
            hospName:'',
            page:1,
            rows:20,
            addHosp:{
                hospName:[{ required: true, message: '请输入医院名称', trigger: 'blur' }],
                hospAdminTel:[{ required: true, trigger: 'blur', validator: validPhone }],
                hospAdminName:[{ required: true, message: '请输入医院负责人', trigger: 'blur' }],
                hospAddr:[{ required: true, message: '请输入医院地址', trigger: 'blur' }],
                hospAddArr:[{ required: true, message: '请选择地区', trigger: 'blur' }],
                hospRank:[{ required: true, message: '请选择医院等级', trigger: 'blur' }]
            },
            hospRanks:[]
        }
    },
    mounted(){
        this.getHospList();
        this.listHospRank()
    },
    methods:{
        //获得医院等级列表
        listHospRank(){
            this.$ajax.post(this.$domain.listHospRank)
            .then((ret)=>{
                var res=ret.data;
                if(res.code=="10"){
                    this.hospRanks=res.data
                }
                else if(res.code=='401'){
                    this.$message.error('登录失效，请重新登录！');
                    this.$router.push({path:'/login'})
                }
            })
        },
        //获取医院列表
        getHospList(){
            var obj={
                page:this.page,
                rows:this.rows,
                hospName:this.hospName
            }
            this.$ajax.post(this.$domain.listHospInfo,obj)
            .then(ret=>{
                var res=ret.data;
                console.log(res);
                if(res.code=="10"){
                    this.hospList=res.data.list;
                    this.tablePage=res.data.count;
                }
                else if(res.code=='401'){
                    this.$message.error('登录失效，请重新登录！');
                    this.$router.push({path:'/login'})
                }
                else{
                    console.log(res)
                }
            })

        },
        // 选择医院
        selectionChange(row){
            this.$common.setStorage('hospMsg',row.hospVo);
            this.$router.push({path:'hospDetail'})
        },
        // 确认添加医院
        save(){
            this.$refs['addForm'].validate((valid) => {
                if (valid) {
                    this.loadingInstance=Loading.service({
                        text:'医院添加中...',
                        spinner:'el-icon-loading',
                        background:'rgba(0, 0, 0, 0.8)'
                    });
                    this.addForm.hospRegionCode=this.addForm.hospAddArr[this.addForm.hospAddArr.length-1];
                    this.$ajax.post(this.$domain.addHosp,this.addForm)
                    .then(ret=>{
                        this.loadingInstance.close();
                        var res=ret.data
                        if(res.code=="10"){
                            this.$message.success('添加成功！');
                            this.cancel();
                            this.hospName=''
                            this.getHospList();
                        }
                        else if(res.code=='401'){
                            this.$message.error('登录失效，请重新登录！');
                            this.$router.push({path:'/login'})
                        }
                        else{
                            console.log(res)
                            this.$message.error('添加失败！');
                        }
                    })
                    .catch(()=>{
                        this.loadingInstance.close();
                    })
                } else {
                    return false;
                }
            })

        },
        // 分页(OK)
        changePage(val){
            this.page=val
            this.getHospList()
        },
        // 分页(OK)
        changeSize(val){
            this.rows=val
            this.getHospList()
        },
        // 取消,清空表单 隐藏dialog
        cancel(){
            this.addForm = {
                hospName:'',
                hospAddr:'',
                hospDesc:'',
                hospAdminName:'',
                hospAdminTel:'',
                hospRegionCode:'',
                hospAddArr:[]
            };
            this.addDialog = false;
            this.$refs['addForm'].resetFields();
        },
        //条件查询医院(OK)
        query(){
            this.page=1
            this.getHospList()
        }
    }
}
</script>

<style>
    .hospImg{
        width:120px;
        height:120px;
        border-radius: 50%;
    }
    #hospManage{
        width:100%;
        min-width: 1200px;
        padding:0 10%;
        box-sizing: border-box;
    }
    #hospManage .breadcrumb{
        width:100%;
        margin:10px auto;
        padding:20px 0;
        box-sizing: border-box;
    }
    .el-table{
        cursor: pointer;
    }
    .el-table .selected-row{
        background:#cee3e9;
    }
    #hospManage .el-cascader{
        width:100%;
    }
    .hospPic{
        height:100px;
        margin-right:20px;
    }
    .el-form-item__content{
        margin-left:0 !important;
        display: flex;
        justify-content: flex-start
    }
    .adminInfo{
        width:80%;
        height:32px;
        border-bottom:1px solid #ccc;
        text-align: left;
        padding-left:2px
    }
    .radioGroup{
        text-align: left;
        margin-top:12px;
        width:100%;
    }
</style>



// WEBPACK FOOTER //
// src/page/hospManage.vue